"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAggregateStatsQuery = exports.useToogleEnableOrDisableUserMutation = exports.useGetDashboardDataQuery = exports.useGetListUserMobileQuery = exports.useUpdateAuthPasswordMutation = exports.useUpdateAuthAvatarMutation = exports.useUpdateAuthUserMutation = exports.useLazyAdminByIdQuery = exports.useDeleteUserMutation = exports.useUnArchiveUserMutation = exports.useArchiveUserMutation = exports.useLazyUserByIdQuery = exports.useGetListAdminUserQuery = exports.useGetStaffListQuery = exports.useAddOrEditAdminMutation = exports.useGetListUserQuery = exports.useChangePasswordMutation = exports.useAddOrEditUserMutation = exports.useLazyMeQuery = exports.useMeQuery = exports.UserApi = exports.prepareHeaders = void 0;
exports.useUserFromLocation = useUserFromLocation;
exports.useAdminFromLocation = useAdminFromLocation;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = require("@reduxjs/toolkit/query/react");
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.UserApi = (0, react_1.createApi)({
    reducerPath: "userApi",
    tagTypes: [
        "user",
        "userList",
        "userById",
        "adminsList",
        "dashboard",
        "adminById",
        "aggregateStats",
    ],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        me: builder.query({
            providesTags: ["user"],
            transformResponse: ({ data }) => data,
            query: () => {
                return "me/";
            },
        }),
        UpdateAuthUser: builder.mutation({
            invalidatesTags: ["user", "adminsList", "userList"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `update-auth-user-infos/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `update-auth-user-infos/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        UpdateAuthAvatar: builder.mutation({
            invalidatesTags: ["user", "adminsList", "userList"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `update-auth-user-avatar/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `update-auth-user-avatar/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        UpdateAuthPassword: builder.mutation({
            invalidatesTags: ["user", "adminsList", "userList"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `update-auth-user-password/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `update-auth-user-password/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        addOrEditUser: builder.mutation({
            invalidatesTags: ["user", "adminsList", "userList"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `users/${id}/`,
                        method: "PUT",
                        body: data,
                    };
                }
                return {
                    url: `users/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        addOrEditAdmin: builder.mutation({
            invalidatesTags: ["userList", "user"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `admin-coll/update/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `admin-coll/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getStaffList: builder.query({
            providesTags: ["userList"],
            query: (query) => (0, Utils_1.QueryUrl)("get-staff", query),
        }),
        changePassword: builder.mutation({
            query: (data) => ({
                url: `auth/change-password/`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["user"],
        }),
        getListUser: builder.query({
            providesTags: ["userList"],
            query: (query) => (0, Utils_1.QueryUrl)("get-users", query),
        }),
        getListUserMobile: builder.query({
            providesTags: ["userList"],
            query: (query) => (0, Utils_1.QueryUrl)("get-users", query),
        }),
        getListAdminUser: builder.query({
            providesTags: ["adminsList"],
            query: (query) => (0, Utils_1.QueryUrl)("user/admins/", query),
        }),
        userById: builder.query({
            query: (slug) => `users/${slug}/`,
            providesTags: ["userById"],
        }),
        archiveUser: builder.mutation({
            query: (slug) => ({
                url: `users/${slug}/`,
                method: "GET",
            }),
            invalidatesTags: ["user", "adminsList", "userList"],
        }),
        unArchiveUser: builder.mutation({
            query: (slug) => ({
                url: `reactive_user/${slug}/`,
                method: "GET",
            }),
            invalidatesTags: ["user", "adminsList", "userList"],
        }),
        deleteUser: builder.mutation({
            query: (slug) => ({
                url: `users/${slug}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["user", "userList", "adminsList"],
        }),
        adminById: builder.query({
            query: (slug) => `admins/${slug}/`,
            providesTags: ["adminById"],
        }),
        getDashboardData: builder.query({
            providesTags: ["dashboard"],
            query: (query) => (0, Utils_1.QueryUrl)("get-dashboard-data", query),
        }),
        toogleEnableOrDisableUser: builder.mutation({
            query: (user_id) => `switchEnableOrDisableUser/${user_id}`,
            invalidatesTags: ["user", "userById", "userList"],
        }),
        getAggregateStats: builder.query({
            providesTags: ["aggregateStats"],
            query: (query) => (0, Utils_1.QueryUrl)("aggregateStats", query),
        }),
    }),
});
exports.useMeQuery = exports.UserApi.useMeQuery, exports.useLazyMeQuery = exports.UserApi.useLazyMeQuery, exports.useAddOrEditUserMutation = exports.UserApi.useAddOrEditUserMutation, exports.useChangePasswordMutation = exports.UserApi.useChangePasswordMutation, exports.useGetListUserQuery = exports.UserApi.useGetListUserQuery, exports.useAddOrEditAdminMutation = exports.UserApi.useAddOrEditAdminMutation, exports.useGetStaffListQuery = exports.UserApi.useGetStaffListQuery, exports.useGetListAdminUserQuery = exports.UserApi.useGetListAdminUserQuery, exports.useLazyUserByIdQuery = exports.UserApi.useLazyUserByIdQuery, exports.useArchiveUserMutation = exports.UserApi.useArchiveUserMutation, exports.useUnArchiveUserMutation = exports.UserApi.useUnArchiveUserMutation, exports.useDeleteUserMutation = exports.UserApi.useDeleteUserMutation, exports.useLazyAdminByIdQuery = exports.UserApi.useLazyAdminByIdQuery, exports.useUpdateAuthUserMutation = exports.UserApi.useUpdateAuthUserMutation, exports.useUpdateAuthAvatarMutation = exports.UserApi.useUpdateAuthAvatarMutation, exports.useUpdateAuthPasswordMutation = exports.UserApi.useUpdateAuthPasswordMutation, exports.useGetListUserMobileQuery = exports.UserApi.useGetListUserMobileQuery, exports.useGetDashboardDataQuery = exports.UserApi.useGetDashboardDataQuery, exports.useToogleEnableOrDisableUserMutation = exports.UserApi.useToogleEnableOrDisableUserMutation, exports.useGetAggregateStatsQuery = exports.UserApi.useGetAggregateStatsQuery;
function useUserFromLocation() {
    const itemState = (0, Utils_1.useLocationState)(undefined);
    const [item, setItem] = (0, react_2.useState)(itemState);
    const { slug } = (0, react_router_dom_1.useParams)();
    const [findById, { data, isError, isLoading }] = (0, exports.useLazyUserByIdQuery)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_2.useEffect)(() => {
        if (slug) {
            findById(slug);
        }
    }, [slug]);
    (0, react_2.useEffect)(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    (0, react_2.useEffect)(() => {
        if (data) {
            setItem(data);
        }
    }, [data]);
    return [item, isLoading, slug, findById];
}
function useAdminFromLocation() {
    const itemState = (0, Utils_1.useLocationState)(undefined);
    const [item, setItem] = (0, react_2.useState)((itemState === null || itemState === void 0 ? void 0 : itemState.id) ? itemState : undefined);
    const { slug } = (0, react_router_dom_1.useParams)();
    const [findById, { data, isError, isLoading }] = (0, exports.useLazyAdminByIdQuery)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_2.useEffect)(() => {
        if (slug) {
            findById(slug);
        }
    }, [slug]);
    (0, react_2.useEffect)(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    (0, react_2.useEffect)(() => {
        if (data) {
            setItem(data);
        }
    }, [data]);
    return [item, isLoading, slug, findById];
}
